module.exports = __webpack_public_path__ + "img/logo_inet.308270ce.png";